import {
  loggerMessageContextValues,
  type LoggerMessage,
  type LoggerMessageBuilderParams,
} from './datadog/types';

export const isBrowser = () => typeof window !== 'undefined';

/**
 * Generates the formatted message with the sessionId included at last
 * and correctly formatted.
 */
export function buildLoggerMessage({
  type,
  context,
  message,
  sessionId,
}: LoggerMessageBuilderParams): LoggerMessage {
  return `[${context} - ${loggerMessageContextValues[type]}] ${message} (SessionId = ${sessionId})`;
}
